import { RouteRecordRaw } from 'vue-router'

import { RESIDENCY_ROUTE_NAMES_NEW } from '@/modules/residency/constants/ResidencyRouteNames'

import { UserGroup } from '@generated/types'

export const residencyRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/residency',
    meta: { requiresAuth: UserGroup.MANAGERS },
    children: [
      {
        path: '',
        name: RESIDENCY_ROUTE_NAMES_NEW.LIST,
        component: () => import('@/modules/residency/pages/ResidencyListNew.vue'),
        meta: { pageTitle: 'Residency List' },
      },
      {
        path: ':residencyId',
        name: RESIDENCY_ROUTE_NAMES_NEW.DETAIL,
        component: () => import('@/modules/residency/pages/ResidencyDetailNew.vue'),
        props: route => {
          const residencyId = route.params.residencyId
          return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
        },
        meta: {
          pageTitle: 'Residency Detail',
          usesCustomNavbar: true,
        },
      },
    ],
  },
]
